import en from "./en"
import fr from "./fr"

const locale =
  localStorage.currentLocale ||
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage ||
  "en-US"

const messages = {
  "en-US": en,
  "fr-CA": fr
}

const supportedLanguages = ["en-US", "fr-CA"]

export { messages, locale, supportedLanguages }



// WEBPACK FOOTER //
// ./src/i18n/index.js